export interface ResourcesLinkRequest {
  application: string;
  applicationId?: string;
  relatedApplicationId?: string;
  username: string;
  cmsDealerNumber: string;
  id: string;
  stateId?: string;
}

export class ResourcesLinkResponse {
  displayName: string;
  links: Link[];
  summary: string;
}

export class Link {
  id: string;
  type: string;
  link: string;
  linkTitle: string;
  paragraphText: string;
}
